import { render, staticRenderFns } from "./PecasLista.vue?vue&type=template&id=43597a76&scoped=true&"
import script from "./PecasLista.vue?vue&type=script&lang=js&"
export * from "./PecasLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43597a76",
  null
  
)

export default component.exports